import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
  OnChanges,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Table, TableModule } from "primeng/table";
import { v4 as uuidv4 } from "uuid";
import { Subject } from "rxjs";
import saveAs from "file-saver";
import * as FileSaver from "file-saver";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ProcessTrackingDetailsList } from "../../../../core/models/orders/processTrackingDetailsList";
import { ProcessTrackingDetailsRequestDto } from "../../../../core/models/orders/processTrackingDetailsRequestDto";
import { SalesOrderNotes } from "../../../../core/models/orders/salesOrderNotes";
import { LoaderService } from "../../../../core/services/loader.service";
import { CommonModule, DatePipe } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { OrderTrackingExcelComponent } from "../order-tracking-excel/order-tracking-excel.component";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ShippingMethod } from "../../../../core/models/shared/shippingMethod";
import { FreightTrackingsDetailValue } from "../../../../core/models/invoice-preview/FreightTrackingsDetailValue";
import { InvoicePreviewSummaryService } from "../../../../core/services/invoice-preview-summary.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { PostFreightTrackingsModel } from "../../../../core/models/invoice-preview/PostFreightTrackingsModel";
import { FormsModule } from "@angular/forms";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { SelectModule } from "primeng/select";
import { DatePickerModule } from "primeng/datepicker";
import { SalesOrderExcelTrackingDto } from "../../../../core/models/orders/salesOrderExcelTrackingDto";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { FreightDetailsComponent } from "../../../bcledger/components/freight-details/freight-details.component";
import { parseShipDate } from "../../../../shared/excel-date/excel-date-utility";
import { CardModule } from "primeng/card";
@UntilDestroy()
@Component({
  selector: "jni-order-tracking",
  templateUrl: "./order-tracking.component.html",
  styleUrls: ["./order-tracking.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    DialogModule,
    OrderTrackingExcelComponent,
    ModalStackerComponent,
    SelectModule,
    FormsModule,
    HidedynamicsdatePipe,
    DatePickerModule,
    InputTextModule,
    ButtonModule,
    FreightDetailsComponent,
    CardModule,
  ],
})
export class OrderTrackingComponent implements OnInit, OnDestroy, OnChanges {
  showSmallLoader = false;
  orderTrackingDisplayModal = false;
  trackingNumber = "";
  @Input() shippingProductsList: ShippingMethod[] = [];
  @Input() salesId = "";
  @Input() projId = "";
  @Input() orderTrackingGridListing: FreightTrackingsDetailValue[] = [];
  @Output() scrollHiddenStatus = new EventEmitter();
  @Input() calculateTotalForAllLines = false;
  @Input() defaultTracking = "0";
  totalSalePrice = 0;
  @Input() salesOrderStatusD365 = "";
  hideAddUploadButtons = false;

  booleanChoice = [
    { enum: "No", value: 0 },
    { enum: "Yes", value: 1 },
  ];

  carriers = [
    { name: "FedEx", value: 0 },
    { name: "UPS", value: 1 },
    { name: "ThirdParty", value: 2 },
    { name: "All", value: 3 },
  ];

  selectedTrackingLine: FreightTrackingsDetailValue[] = [];

  shipDateCurrentdate = new Date();

  showUploadExcel = false;

  jniAcctSubject = new Subject<{ portalKey: string; jniAcct: string }>();

  @Input() fromStacker = false;
  @Output() refreshMainGrid = new EventEmitter();
  @Output() showSeeAllButtonEvent = new EventEmitter<boolean>();
  @Output() getOrderNotesEvent = new EventEmitter();
  @Output() closeModalEvent = new EventEmitter();

  @ViewChild("dt") table!: Table;

  constructor(
    private _loaderService: LoaderService,
    private _invoicePreviewSummaryService: InvoicePreviewSummaryService,
    private _toastr: JniToastrService,
    private _samplepoListingService: SamplepoListingService,
    private _dataPipe: DatePipe
  ) {}

  ngOnInit(): void {
    if (this.salesId && !this.calculateTotalForAllLines) {
      this.getOrderTrackingDataAgainstSaleOrder(this.salesId);
    }

    this.jniAcctValue();
  }

  exportExcel() {
    const object = this.orderTrackingGridListing.map(datum => {
      return {
        ["PO #"]: datum?.PurchId,
        ["Bill Rec"]: datum?.BillRecieved,
        ["JNIAcct"]: datum?.FreightAccount,
        ["Ship Date"]: datum?.ShipDate,
        ["Deliv Date"]: datum?.DeliveryDate,
        ["Carrier"]: datum?.Carrier === "All" ? "" : datum?.Carrier,
        ["Tracking"]: datum?.TrackingNumber,
        ["Weight"]: datum?.Weight,
        ["Sale Price"]: datum?.SellPrice,
        ["Ship Method"]: datum?.DlvModeDescription,
        ["Shipper Name"]: datum?.ShipperName,
        ["Shipped From"]: datum?.ShipFromAddress,
        ["S-Ctry"]: datum?.ShipperCountry,
        ["Recipient Name"]: datum?.RecipientName,
        ["Recipient Address"]: datum?.ShipToAddress,
        ["R-Ctry"]: datum?.RecipientCountry,
        ["Sales Order"]: datum?.SalesId,
        ["JNI Reference 2"]: datum?.JNIReference2,
        ["JNI Reference 3"]: datum?.JNIReference3,
        ["JNI Reference 4"]: datum?.JNIReference4,
        ["JNI Reference 5"]: datum?.JNIReference5,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "OrderTracking");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  getOrderTrackingDataAgainstSaleOrder(salesId: string) {
    if (this.fromStacker) {
      this._loaderService.setLoaderState(true);
      const oDataFilter = `?$filter=SalesId eq '${salesId}'`;
      this._invoicePreviewSummaryService
        .getFreightTrackingLine(oDataFilter)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: GenericResponseDto<FreightTrackingsDetailValue[]>) => {
            res.data.forEach(x => {
              x.PortalKey = uuidv4();
            });
            this.selectedTrackingLine = [];
            this.orderTrackingGridListing = res.data;

            this._loaderService.setLoaderState(false);
            this.totalSalePrice = this.orderTrackingGridListing.reduce(
              (sum, el) => (sum += el.SellPrice),
              0
            );
            //this.calculateTotals();  OptimzationWork 27-02-2025
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    } else {
      this.selectedTrackingLine = [];
      this.refreshMainGrid.emit();
    }
  }

  onTrackingNumberSelection(trackingNumber: string) {
    if (trackingNumber) {
      this.trackingNumber = trackingNumber;
      this.orderTrackingDisplayModal = true;
    }
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<ShippingMethod[]>) => {
          const shippingData = res.data;
          this.shippingProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
        },
      });
  }

  closeModalFromOrderTracking() {
    this.orderTrackingDisplayModal = false;
  }

  addScollHiddenClass() {
    this.scrollHiddenStatus.emit();
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  ngOnChanges(): void {
    if (this.salesOrderStatusD365 === "Invoiced") {
      this.hideAddUploadButtons = true;
    }

    //this.calculateTotals(); //OptimzationWork 27-02-2025
  }

  addIpTrackingLine() {
    this.cancelAllEditRow();
    const tracking = {
      SalesId: this.salesId,
      ProjId: this.projId,
      PortalKey: uuidv4(),
      DataAreaId: "jni",
    } as FreightTrackingsDetailValue;

    this.orderTrackingGridListing.push(tracking);
    this.table.initRowEdit(this.table.value[this.table.value?.length - 1]);
  }

  uploadIpTrackingLine() {
    this.showUploadExcel = true;
  }

  closeUploadIpTrackingLine() {
    this.showUploadExcel = false;
  }

  closeModalDialog() {
    this.showUploadExcel = false;
  }

  deleteIpTrackingLine() {
    if (
      this.selectedTrackingLine &&
      Object.keys(this.selectedTrackingLine).length
    ) {
      const del = this.selectedTrackingLine[0] || this.selectedTrackingLine;
      if (del?.MatchStatus == "Matched") {
        this._toastr.error("Matched line can not be deleted");
        return;
      }
      if (del?.CreatedByPortal && del?.CreatedByPortal === "No") {
        this._toastr.error("Can Not delete a Line Created from D365");
        return;
      }

      if (!del?.FreightNumber) {
        const index = this.orderTrackingGridListing.findIndex(
          x => x.PortalKey == del.PortalKey
        );

        if (index > -1) {
          this.orderTrackingGridListing.splice(index, 1);
        }
      } else {
        this._loaderService.setLoaderState(true);
        this._invoicePreviewSummaryService
          .postFreightTrackingsDelete(del)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (
                res.data &&
                (res.data.statusCode == 204 ||
                  res.data.statusCode.toString() == "204")
              ) {
                this.selectedTrackingLine = [];
              }

              this.getOrderTrackingDataAgainstSaleOrder(this.salesId);
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      }
    }
  }

  // onEditRow(tracking: FreightTrackingsDetailValue) {}

  onSaveRow(tracking: FreightTrackingsDetailValue) {
    if (tracking && tracking && Object.keys(tracking).length) {
      tracking.DlvModeDescription =
        this.shippingProductsList.find(
          x => x.modeCodeD365 == tracking.DlvModeId
        )?.modeDescriptionD365 ?? "";
      const trackingPost = this.convertToPostModels(tracking);
      if (!trackingPost.TrackingNumber) {
        this._toastr.error("Tracking missing");
        return;
      }

      const carrier = this.carriers.find(x => x.name == tracking.Carrier);

      if (carrier && Object.keys(carrier).length) {
        tracking.Carrier = carrier.value.toString();
        tracking.CarrierId = carrier.name;
      }

      if (tracking.Carrier != "0" && !tracking.Carrier) {
        tracking.Carrier = "3";
        const carrier = this.carriers.find(
          x => x.value == Number.parseInt(tracking.Carrier)
        );

        tracking.CarrierId = carrier?.name ?? "";
      }

      if (tracking.FreightAccount) {
        if (typeof tracking.FreightAccount == "number") {
          if (tracking.FreightAccount) {
            tracking.FreightAccount = "1";
          } else {
            tracking.FreightAccount = "0";
          }
        } else {
          if ((tracking.FreightAccount[0] as string)?.toLowerCase() == "y") {
            tracking.FreightAccount = "1";
          } else {
            tracking.FreightAccount = "0";
          }
        }
      } else {
        tracking.FreightAccount = "0";
      }

      const createUpdateObj = this.convertCreateUpdateModels(tracking);
      const payload = {
        FreightTrackingDetails: createUpdateObj,
      } as ProcessTrackingDetailsRequestDto;

      this.postFreightTrackingsCreateExcel(payload);

      // this._loaderService.setLoaderState(true);
      // if (!tracking.FreightNumber) {
      //   this._invoicePreviewSummaryService
      //     .postFreightTrackingsCreate(trackingPost)
      //     .pipe(untilDestroyed(this))
      //     .subscribe({
      //       next: (res) => {
      //         this._loaderService.setLoaderState(false);

      //         this.getOrderTrackingDataAgainstSaleOrder(
      //           this.salesId,
      //           this.projId
      //         );
      //       },
      //       error: (res) => {
      //         this._loaderService.setLoaderState(false);
      //       }
      //     });
      // } else {
      //   this._invoicePreviewSummaryService
      //   .postFreightTrackingsCreate(trackingPost)
      //   .pipe(untilDestroyed(this))
      //   .subscribe({
      //     next: (res) => {
      //       this._loaderService.setLoaderState(false);

      //       this.getOrderTrackingDataAgainstSaleOrder(
      //         this.salesId,
      //         this.projId
      //       );
      //     },
      //     error: (res) => {
      //       this._loaderService.setLoaderState(false);
      //     }
      //   });
      // }
    }
  }

  trackingChanged(event: FreightTrackingsDetailValue) {
    this.jniAcctSubject.next({
      portalKey: event.PortalKey,
      jniAcct: event.FreightAccount,
    });
  }

  jniAcctValue() {
    this.jniAcctSubject.subscribe(x => {
      if (x?.portalKey) {
        const index = this.orderTrackingGridListing.findIndex(
          y => y.PortalKey == x.portalKey
        );
        if (index > -1 && x.jniAcct) {
          if (x.jniAcct) {
            this.orderTrackingGridListing[index].BillRecieved = "No";
          } else {
            this.orderTrackingGridListing[index].BillRecieved = "";
          }
        }
      }
    });
  }

  calculateTotals() {
    if (this.calculateTotalForAllLines && this.salesId) {
      const oDataFilter = `?$filter=SalesId eq '${this.salesId}'`;
      this._invoicePreviewSummaryService
        .getFreightTrackingLine(oDataFilter)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: GenericResponseDto<FreightTrackingsDetailValue[]>) => {
            if (res?.data && res?.data?.length > 0) {
              this.totalSalePrice = res.data.reduce(
                (sum, el) => (sum += el.SellPrice),
                0
              );
            }
            if (res?.data?.length > Number.parseInt(this.defaultTracking)) {
              this.showSeeAllButtonEvent.emit(true);
            } else {
              this.showSeeAllButtonEvent.emit(false);
            }
          },
        });
    } else {
      this.totalSalePrice = this.orderTrackingGridListing.reduce(
        (sum, el) => (sum += el.SellPrice),
        0
      );
    }
  }

  convertToPostModels(tracking: FreightTrackingsDetailValue) {
    const postTracking = {
      BillRecieved: tracking.BillRecieved ?? "No",
      ShipDate: tracking.ShipDate ?? "",
      DeliveryDate: tracking.DeliveryDate ?? "",
      Carrier: tracking.Carrier ?? "",
      TrackingNumber: tracking.TrackingNumber,
      Weight: tracking.Weight ?? 0,
      SalesId: tracking.SalesId,
      PurchId: tracking.PurchId,
      DataAreaId: "jni",
      FreightNumber: tracking.FreightNumber,
      DlvModeDescription: tracking.DlvModeDescription,
      DlvModeId: tracking.DlvModeId,
      FreightAccount: tracking.FreightAccount ?? "No",
      ShipperZipCode: tracking.ShipperZipCode ?? "",
      ShipperStreet: tracking.ShipperStreet ?? "",
      ShipperState: tracking.ShipperState ?? "",
      ShipperName: tracking.ShipperName ?? "",
      ShipperCompany: tracking.ShipperName ?? "",
      ShipperCountry: tracking.ShipperCountry ?? "",
      ShipperCity: tracking.ShipperCity ?? "",
      SellPrice: tracking.SellPrice ?? 0,
      RecipientZipCode: tracking.ShipperZipCode ?? "",
      RecipientStreet: tracking.RecipientStreet ?? "",
      RecipientState: tracking.RecipientState ?? "",
      RecipientName: tracking.RecipientName ?? "",
      RecipientCompany: tracking.RecipientName ?? "",
      RecipientCountry: tracking.RecipientCountry ?? "",
      RecipientCity: tracking.RecipientCity ?? "",
      ProjId: this.projId,
    } as PostFreightTrackingsModel;

    return postTracking;
  }

  convertCreateUpdateModels(tracking: FreightTrackingsDetailValue) {
    const arrayList: ProcessTrackingDetailsList[] = [];

    const postTracking = {
      BillRecieved: tracking.BillRecieved || "No",
      ShipDate: this._dataPipe.transform(
        tracking.ShipDate ||
          new Date(Date.UTC(1900, 0, 1)).toISOString().slice(0, 10),
        "yyyy-MM-dd"
      ),
      DeliveryDate: this._dataPipe.transform(
        tracking.DeliveryDate ||
          new Date(Date.UTC(1900, 0, 1)).toISOString().slice(0, 10),
        "yyyy-MM-dd"
      ),
      TrackingNumber: tracking.TrackingNumber,
      Weight: tracking.Weight ?? 0,
      SalesId: tracking.SalesId,
      PurchId: tracking.PurchId,
      DataAreaId: "jni",
      FreightNumber: tracking.FreightNumber,
      DlvModeDescription: tracking.DlvModeDescription,
      DlvModeId: tracking.DlvModeId,
      FreightAccount: tracking.FreightAccount ?? "0",
      ShipperZip: tracking.ShipperZipCode ?? "",
      ShipperStreet: tracking.ShipperStreet ?? "",
      ShipperState: tracking.ShipperState ?? "",
      ShipperName: tracking.ShipperName ?? "",
      ShipperCompany: tracking.ShipperName ?? "",
      ShipperCountry: tracking.ShipperCountry ?? "",
      ShipperCity: tracking.ShipperCity ?? "",
      SellPrice: tracking.SellPrice ?? 0,
      RecipientZip: tracking.ShipperZipCode ?? "",
      RecipientStreet: tracking.RecipientStreet ?? "",
      RecipientState: tracking.RecipientState ?? "",
      RecipientName: tracking.RecipientName ?? "",
      RecipientCompany: tracking.RecipientName ?? "",
      RecipientCountry: tracking.RecipientCountry ?? "",
      RecipientCity: tracking.RecipientCity ?? "",
      ProjId: this.projId,
      BilledToType: tracking.BilledToType ?? "2",
      BillToRef: tracking.BilledToReference,
      CarrierId: tracking.CarrierId, // this.carriers.filter(x => x.name === tracking.CarrierId ?? x.value.toString()=== tracking.CarrierId)[0].name,
      Carrier: (tracking.Carrier ?? "0").toString(), //tracking.CarrierId,
      CustAccount: tracking.CustAccount,
      MatchStatus: tracking.MatchStatus ?? "0",
      PODName: tracking.PODName,
      ProjectID: tracking.ProjId,
      PurchID: tracking.PurchId,
      ShipStatus: tracking.ShipStatus,
      ShippingMethod: tracking.DlvModeId,
      JNIReference2: tracking.JNIReference2 ?? "",
      JNIReference3: tracking.JNIReference3 ?? "",
      JNIReference4: tracking.JNIReference4 ?? "",
      JNIReference5: tracking.JNIReference5 ?? "",
    } as ProcessTrackingDetailsList;

    arrayList.push(postTracking);
    return arrayList;
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  deliveryDateChange(event: Date, line: FreightTrackingsDetailValue) {
    line.DeliveryDate = (event ?? "").toString();
  }

  shipDateChange(event: Date, line: FreightTrackingsDetailValue) {
    const deliveryDate = new Date(line.DeliveryDate);
    if (deliveryDate < event) {
      line.DeliveryDate = (event ?? "").toString();
    }
  }

  excelData(event: SalesOrderExcelTrackingDto[]) {
    this.showUploadExcel = false;
    for (const item of event) {
      if (!item.Trackingnumber) {
        this._toastr.error("Tracking missing");
        return;
      }

      if (item.Order && item.Order != this.salesId) {
        this._toastr.error("Order Number Mismatch");
        return;
      }
    }
    this.excelToTrackingList(event);
  }

  // onShipDateSelection(event: any) {
  //   // const date = new Date(event);
  //   // this.shipDate = this.datepipe.transform(date, 'MM/dd/yyyy') || '';
  //   // if (this.shipDate) {
  //   //   this.inHandDateCurrentdate = new Date(this.shipDate);
  //   // } else {
  //   //   this.inHandDateCurrentdate = new Date();
  //   // }
  //   // this.parent.patchValue({
  //   //   orderHeader: {
  //   //     shipDate: this.shipDate
  //   //   }
  //   // });
  // }

  excelToTrackingList(data: SalesOrderExcelTrackingDto[]) {
    const excelList: ProcessTrackingDetailsList[] = [];
    for (const item of data) {
      const tracking = {
        ProjectID: this.projId ?? "",
        TrackingNumber: item.Trackingnumber?.toString() ?? "",
        PurchID: item.Purchaseorder ?? "",
        SalesId: item.Order?.toString() ?? this.salesId, //item.Purchaseorder.slice(0, -1) || '',
        Carrier: item.Carrier ?? "",
        ShipDate: item["Ship date"],
        ShipperName: item.ShipFromName ?? "",
        ShipperCompany: item.ShipFromName ?? "",
        RecipientName: item.ShipToName ?? "",
        RecipientCompany: item.ShipToName ?? "",
        ShipperCity: item.ShipFromCity ?? "",
        ShipperState: item.ShipFromState ?? "",
        ShipperZip: item.ShipFromZip ?? "",
        ShipperStreet: item.ShipFromStreet ?? "",
        ShipperCountry: item.ShipFromCountry ?? "",
        RecipientCity: item.ShipToCity ?? "",
        RecipientState: item.ShipToState ?? "",
        RecipientZip: item.ShipToZip ?? "",
        RecipientStreet: item.ShipToStreet ?? "",
        RecipientCountry: item.ShipToCountry ?? "",
      } as ProcessTrackingDetailsList;

      const shipDate = parseShipDate(tracking.ShipDate)?.toISOString();

      if (shipDate) {
        const splitDate = shipDate.split("T")[0];
        if (splitDate) {
          const [year, month, day] = splitDate.split("-");

          if (day && (month || month == "0") && year) {
            const date = new Date(
              Number.parseInt(year),
              Number.parseInt(month) - 1,
              Number.parseInt(day)
            );
            tracking.ShipDate = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            ).toISOString();
          }
        }
      }

      const selectedCarrier = this.carriers.find(x => x.name == item.Carrier);

      if (item.JNIAcct != null && item.JNIAcct !== "") {
        const flag = String(item.JNIAcct).charAt(0).toLowerCase();
        tracking.FreightAccount = flag === "y" ? "1" : "0";
      } else {
        tracking.FreightAccount = "0";
      }

      if (selectedCarrier) {
        tracking.Carrier = selectedCarrier.value.toString();
        tracking.CarrierId = selectedCarrier.name;
      } else {
        tracking.Carrier = "3";
        tracking.CarrierId = "All";
      }

      excelList.push(tracking);
    }

    const payload = {
      FreightTrackingDetails: excelList,
    } as ProcessTrackingDetailsRequestDto;

    this.postFreightTrackingsCreateExcel(payload, true);
  }

  postFreightTrackingsCreateExcel(
    payload: ProcessTrackingDetailsRequestDto,
    displayUploadMessage = false
  ) {
    this._loaderService.setLoaderState(true);
    this._invoicePreviewSummaryService
      .PostFreightTrackingsCreateExcel(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res?.data?.Failed.startsWith("0")) {
            let trackingNumbers = "";
            if (payload?.FreightTrackingDetails?.length) {
              payload.FreightTrackingDetails.forEach(
                x =>
                  (trackingNumbers = `${trackingNumbers}${
                    trackingNumbers ? ", " : ""
                  }${x.TrackingNumber}`)
              );
            }

            if (displayUploadMessage) {
              this.createOrderNoteForExcelUpload(trackingNumbers);
              this._toastr.success("Upload Complete");
            }
          } else {
            this._toastr.error(
              res?.data?.Failed ??
                "Error occurred in D365 while uploading tracking details"
            );
          }

          this.getOrderTrackingDataAgainstSaleOrder(this.salesId);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getFreightTrackingExcelTemplate() {
    this._loaderService.setLoaderState(true);
    this._invoicePreviewSummaryService
      .getFreightTrackingExcelTemplate()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.downloadFile(res);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  downloadFile(data: Blob) {
    const file = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(file, `FreightTracking_Template.xlsx`);
  }

  createOrderNoteForExcelUpload(trackingNumbers: string) {
    const saleOrderFormObject = {
      description: "Freight Tracking Excel Uploaded",
      id: 0,
      note: `Tracking Number ${trackingNumbers} Uploaded for Order# ${
        this.salesId
      } at ${new Date().toLocaleString("en-US", {
        timeZone: "America/Los_Angeles",
      })}`,
      portalKey: uuidv4(),
      purchaseOrderStatus: false,
      salesOrderId: this.salesId,
      type: "Order note",
    } as SalesOrderNotes;

    this._invoicePreviewSummaryService
      .AddSalesOrderNotes(saleOrderFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.success("Success", "Order Note Added Successfully");
          this.getOrderNotesEvent.emit();
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message ?? "Error adding order note");
        },
      });
  }

  closeModal() {
    this.closeModalEvent.emit();
  }
}
